import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { GetClientsResult } from './get-clients-result.generated';

@Injectable({
    providedIn: 'root'
})
export class GetClientsService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getClients(options?: ApiProxyOptions): Observable<GetClientsResult> {
        return this._concurrentRequestHandlingService.callApi<GetClientsResult>(
            "GetClientsService_getClients",
            {
                url: '/Navigation/GetClients/GetClients',
                body: {},
                sendCredentials: true
            }, options
        );
    }
}
